import React, { useMemo, useEffect } from "react";
import styles from "./ProfileCompletion.module.css";

/* ---------- helper: decides if a field is filled ---------- */
const isFilled = (value) => {
  // string
  if (typeof value === "string") {
    return value.trim().length > 0;
  }

  // boolean (checkboxes)
  if (typeof value === "boolean") {
    return value === true;
  }

  // file input
  if (value instanceof FileList) {
    return value.length > 0;
  }

  // null / undefined
  if (value === null || value === undefined) {
    return false;
  }

  // array (FIXES socialMediaLinks & academicLinks)
  if (Array.isArray(value)) {
    return value.some((item) => {
      // array of strings
      if (typeof item === "string") {
        return item.trim().length > 0;
      }

      // array of objects
      if (typeof item === "object" && item !== null) {
        return Object.values(item).some(
          (v) => String(v || "").trim().length > 0
        );
      }

      return false;
    });
  }

  // select object { label, value }
  if (typeof value === "object") {
    if ("value" in value || "label" in value) {
      return (
        String(value.value || "").trim().length > 0 ||
        String(value.label || "").trim().length > 0
      );
    }

    // generic object
    return Object.values(value).some((v) => String(v || "").trim().length > 0);
  }

  // number
  if (typeof value === "number") {
    return true;
  }

  return false;
};

export default function ProfileCompletion({
  watch,
  exclude = [],
  onChange,
  isEditable,
  setIsEdiatble,
}) {
  const values = watch();

  const { total, completed } = useMemo(() => {
    const entries = Object.entries(values).filter(
      ([key]) => !exclude.includes(key)
    );

    let totalFields = entries.length;
    let completedFields = 0;

    entries.forEach(([_, value]) => {
      if (isFilled(value)) {
        completedFields++;
      }
    });

    return { total: totalFields, completed: completedFields };
  }, [values, exclude]);

  const percentage = total === 0 ? 0 : Math.round((completed / total) * 100);

  useEffect(() => {
    if (onChange) onChange(percentage);
  }, [percentage, onChange]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.topHeading}>
        <div className={styles.label}>Profile Completeness — {percentage}%</div>
        {!isEditable && (
          <button
            type="button"
            className={styles.edit}
            onClick={(e) => {
              e.preventDefault(); // extra safety
              setIsEdiatble(true);
            }}
          >
            Edit Profile
          </button>
        )}
      </div>
      <div className={styles.progressBox}>
        <div
          className={styles.progressFill}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}
